module.exports = __webpack_public_path__ + "img/close-circle.e57d5ffd.png";